import { getCachedDateOfNow } from "#web/utils/getCachedDateOfNow";
import * as v from "valibot";

import { LeakedCode } from "../leakedCode";

export const makeFakeLeakedCode = (props: Partial<LeakedCode>): LeakedCode =>
  v.parse(LeakedCode, {
    code: "HOTPUFF",
    codeEndsAt: new Date(getCachedDateOfNow().getTime() + 6 * 7 * 24 * 60 * 60 * 1000),
    codeStartsAt: new Date(getCachedDateOfNow().getTime() - 1 * 7 * 24 * 60 * 60 * 1000),
    id: "1",
    isCurrentlyLeaked: true,
    isHighRisk: false,
    lastScrapedAt: getCachedDateOfNow(),
    leakedAt: getCachedDateOfNow(),
    leakedOnAppInstallation: false,
    leakedSiteMetadata: {
      couponfollow: {
        description:
          "Luxy Hair Promo Code: Get $20 Off Orders $80+ - Redeem this promo code at checkout and save $20 on orders over $80.",
        terms: "Redeem this promo code at checkout and save $20 on orders over $80.",
        verification_date: "2025-03-20T17:01:00.698718",
        verified: true,
      },
    },
    shopId: "1",
    shopifyDiscountCodeId: "1",
    shopifyPriceRuleId: "1",
    sources: [
      {
        name: "Honey",
        url: "devstorekeepcart.myshopify.com",
      },
      {
        name: "blocking",
        url: "test.de",
      },
      {
        name: "CouponExtension",
        url: "devstorekeepcart.myshopify.com",
      },
      {
        name: "Other extension",
        url: "devstorekeepcart.myshopify.com",
      },
    ],
    value: 25,
    valueType: "percentage",
    ...props,
  } satisfies LeakedCode);

export const highRiskCode = makeFakeLeakedCode({
  id: "1",
  isHighRisk: true,
});

export const lowRiskCode = makeFakeLeakedCode({
  id: "2",
  isHighRisk: false,
});

export const currentlyLeakedCode = makeFakeLeakedCode({
  id: "3",
  isCurrentlyLeaked: true,
});

export const notCurrentlyLeakedCode = makeFakeLeakedCode({
  code: "NOTLEAKED",
  id: "4",
  isCurrentlyLeaked: false,
});

export const leaked6weeksAgo = makeFakeLeakedCode({
  code: "WELCOME",
  id: "5",
  leakedAt: new Date(getCachedDateOfNow().getTime() - 6 * 7 * 24 * 60 * 60 * 1000),
});

export const leakedNow = makeFakeLeakedCode({
  code: "WEATHER",
  id: "6",
  leakedAt: getCachedDateOfNow(),
});

export const leaked1weekAgo = makeFakeLeakedCode({
  code: "123456",
  id: "7",
  leakedAt: new Date(getCachedDateOfNow().getTime() - 7 * 24 * 60 * 60 * 1000),
});

export const fixedValueCode = makeFakeLeakedCode({
  id: "8",
  value: 10,
  valueType: "fixed",
});

export const shopifyExpiredCode = makeFakeLeakedCode({
  codeEndsAt: new Date(getCachedDateOfNow().getTime() - 1 * 24 * 60 * 60 * 1000),
  id: "9",
  shopifyDiscountCodeId: null,
  shopifyPriceRuleId: null,
});

export const leakedOnAppInstallation = makeFakeLeakedCode({
  code: "APPINSTALLATION",
  id: "10",
  leakedOnAppInstallation: true,
});

export const variousFakeLeakedCodes = [
  currentlyLeakedCode,
  notCurrentlyLeakedCode,
  leaked6weeksAgo,
  leakedNow,
  leaked1weekAgo,
  highRiskCode,
  lowRiskCode,
  fixedValueCode,
  shopifyExpiredCode,
  leakedOnAppInstallation,
];
